import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY
);

export const SUPABASE_BUCKET = process.env.REACT_APP_SUPABASE_BUCKET || 'event-media';
